<template>
	<table id="vgt-table" class="vgt-table striped vgt-compact">
		<thead>
			<tr class="vgt-left-align sortable">
				<th v-for="column in columns" :key="column.label" class="vgt-left-align sortable">
					{{ column.label }}
				</th>
			</tr>
		</thead>
		<tbody>
			<draggable style="display: contents" :list="rows" @change="$emit('drag-end', $event)">
				<tr v-for="row in rows" :key="row.id">
					<td
						v-for="column in columns"
						:key="column.field"
						class="vgt-left-align"
						@click="$emit('on-row-click', { row })"
					>
						<slot
							name="table-row"
							:row="row"
							:column="column"
							:collect="collect(row, column.field)"
						>
							{{ collect(row, column.field) }}
						</slot>
					</td>
				</tr>
			</draggable>
		</tbody>
	</table>
</template>

<script>
import draggable from 'vuedraggable';

export default {
	name: 'DraggableTable',
	components: {
		draggable,
	},
	props: {
		columns: {
			type: Array,
			required: true,
			default: () => [],
		},
		rows: {
			type: Array,
			required: true,
			default: () => [],
		},
	},
	methods: {
		collect(obj, field) {
			// utility function to get nested property
			// eslint-disable-next-line no-shadow
			function dig(obj, selector) {
				let result = obj;
				const splitter = selector.split('.');
				for (let i = 0; i < splitter.length; i += 1) {
					if (typeof result === 'undefined') return undefined;
					result = result[splitter[i]];
				}
				return result;
			}

			if (typeof field === 'function') return field(obj);
			if (typeof field === 'string') return dig(obj, field);
			return undefined;
		},
	},
};
</script>

<style lang="scss" scoped>
.sortable-chosen {
	background: #ded6fd !important;
}

.sortable-ghost {
	opacity: 0.5;
	cursor: grabbing !important;
}

tbody {
	cursor: pointer;
}

th {
	padding: 0.75em 1.5em 0.75em 0.75em;
}
</style>

